module.exports = __webpack_public_path__ + "img/metting.87a1911c.jpg";